export default "assets/images/logo-06bf6c78.png";